import { action } from 'satcheljs';
import type { MailboxInfo } from 'owa-client-types';

/**
 * Dispatched when a persistent (pinned) taskpane instance is created for an item.
 * Scenarios that need to apply an overlay at taskpane creation time (e.g., decryption
 * in progress) should register an orchestrator on this action to check their conditions
 * and call setTaskPaneErrorType if applicable.
 */
export interface OnPersistentTaskPaneOpenedActionMessage {
    hostItemIndex: string;
    targetWindow: Window;
    mailboxInfo: MailboxInfo;
}

const onPersistentTaskPaneOpened: (
    hostItemIndex: string,
    targetWindow: Window,
    mailboxInfo: MailboxInfo
) => OnPersistentTaskPaneOpenedActionMessage = action(
    'onPersistentTaskPaneOpened',
    (
        hostItemIndex: string,
        targetWindow: Window,
        mailboxInfo: MailboxInfo
    ): OnPersistentTaskPaneOpenedActionMessage => ({
        hostItemIndex,
        targetWindow,
        mailboxInfo,
    })
);
export default onPersistentTaskPaneOpened;
